import { ImageState } from '@/store/update-event/@types/image';

export const initialImageState: ImageState = {
  uploadedImages: [],
  files: [],
  preview: [],
  allImages: [],
  isLoading: false,
};
